import { COMPANY_TIER } from '@demandproai/shared';
import LoggedInUserService from '../services/AuthService';

const useCompanyTier = () => {
    const user = LoggedInUserService.GetLoggedInUserData();
    const tier = user?.tier || null;
    const isSilverTier = tier === COMPANY_TIER.SILVER;
    const isDiamondTier = tier === COMPANY_TIER.DIAMOND;

    return { 
        tier, 
        isSilverTier,
        isDiamondTier 
    };
};

export default useCompanyTier;
